import React from 'react';

import {
  Loader,
} from '@resy/ui-kitchen';

import './BookingLoading.scss';

const BookingLoading = () => (
  <div className="BookingLoading">
    <Loader className="BookingLoading" />
  </div>
);

BookingLoading.displayName = 'BookingLoading';
export default BookingLoading;
